export default __webpack_public_path__ + "static/media/63.502112c8.png";